import React from 'react';
import {componentName, selectImageFile} from '../utils';

import i18n from 'i18next';

const I18N_MAX_ONE_KEY = 'wisbitPage.selectComponentType.maximumOne';

interface ComponentListItemProps {
  value: string;
  disabled?: boolean;
  onClick: () => void;
}

export default function ComponentListItem(props: ComponentListItemProps) {
  return (
    <li
      className={`first:rounded-t-large last:rounded-b-large flex items-center py-1 px-2 border-t-skyblue cursor-pointer ${
        props.disabled ? 'opacity-75' : ''
      }`}
      onClick={props.onClick}
    >
      <img src={selectImageFile(props.value)} alt={props.value} />
      <span>{`${props.disabled ? i18n.t(I18N_MAX_ONE_KEY) : ''}${componentName(
        props.value
      )}`}</span>
    </li>
  );
}
